import { render } from "./SyncList.vue?vue&type=template&id=7c4500d6&scoped=true"
import script from "./SyncList.vue?vue&type=script&lang=ts"
export * from "./SyncList.vue?vue&type=script&lang=ts"

import "./SyncList.vue?vue&type=style&index=0&id=7c4500d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c4500d6"

export default script